import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useMemo, useState} from 'react';
import {Platform, View} from 'react-native';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../../../data/types/interface/api';
import {
  IData,
  IDataWs,
  IDisplay,
} from '../../../../../data/types/interface/Contrats/souscriptionContrat';
import {StackParams} from '../../../../../data/types/navigation';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../../components/Header/HeaderScreen';
import Label from '../../../../components/Label';
import {Loader} from '../../../../components/Loader';
import {ProduitItem} from '../../../../components/ProduitItem';
import globalStyle from '../../../../styles/globalStyle';
import {styles} from '../styles';

type NavigationProps = StackNavigationProp<
  StackParams,
  'EpargneEtPrevoyanceContrat'
>;

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCategorieTypeassurance: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route: any;
}

export function EpargneEtPrevoyanceContratScreen(props: Props) {
  const {navigate} = useNavigation<NavigationProps>();
  const {getCategorieTypeassurance} = props;
  const [listItem, setListItem] = useState<Array<IDataWs>>();
  const categorieId =
    props && props.route && props.route.params && props.route.params.id;
  useEffect(() => {
    getCategorieTypeassurance(
      {},
      (res: ApiResponse) => {
        setListItem(res && res.data && res.data.items);
      },
      `?categorieId=${categorieId}`,
    );
  }, [getCategorieTypeassurance]);

  const aList: IData[] = useMemo(
    () => [
      {
        libelle: 'Assurance Retraite',
        navigate: () => {
          navigate('EpargneEtPrevoyanceContrat');
        },
        destinationPage: 'SouscriptionAssuranceRetraiteForm',
        id: '',
        data: '',
        montant: ' ',
      },
    ],
    [],
  );

  const datas = useMemo(
    () =>
      listItem
        ? aList.map((elt, i) => {
            elt.id = listItem[i].id;
            elt.imageUrl = 'assurance-retraite.png';

            return elt;
          })
        : [],
    [listItem, aList],
  );

  const display: IDisplay = {items: []};
  display.items = datas;

  const containerStyle =
    Platform.OS === 'web' ? globalStyle.containerFluid : styles.ListContainer;

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Compte > Souscrire un Contrat > Epargne et prévoyance"
        type="retour"
        noBreadcrumb={false}
      />
      <View style={containerStyle}>
        <View style={styles.ListLibelle}>
          <Label title="EPARGNE ET PREVOYANCE" type="mainTitle" />
        </View>
        {display.items.length <= 0 ? (
          <Loader />
        ) : (
          <ProduitItem data={display} />
        )}
      </View>
    </View>
  );
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EpargneEtPrevoyanceContrat: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpargneEtPrevoyanceContratScreen);
